import { SvgIcon, SvgIconProps } from '@mui/material';
import './ccf-voice-mail-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfVoiceMailIconProps extends SvgIconProps {}

/**
 * Component used to show voice mail icon
 * @param props -  CcfVoiceMailIconProps
 * @example
 * @returns
 */
export function CcfVoiceMailIcon(props: CcfVoiceMailIconProps) {
  return (
    <SvgIcon width="30" height="16" viewBox="0 0 30 16" fill="none" {...props}>
      <path d="M22.95 11.6C20.7 11.6 18.9 9.8 18.9 7.55C18.9 5.3 20.7 3.5 22.95 3.5C25.2 3.5 27 5.3 27 7.55C27 9.8 25.2 11.6 22.95 11.6ZM7.05 11.6C4.8 11.6 3 9.8 3 7.55C3 5.3 4.8 3.5 7.05 3.5C9.3 3.5 11.1 5.3 11.1 7.55C10.95 9.8 9.3 11.6 7.05 11.6ZM22.95 0.5C19.05 0.5 15.9 3.65 15.9 7.55C15.9 10.1 16.65 11.3 18.6 12.5C10.2 12.5 10.2 12.5 10.2 12.5C12.15 11.3 13.95 9.95 13.95 7.55C13.95 3.65 10.95 0.5 7.05 0.5C3.15 0.5 0 3.65 0 7.55C0 11.45 3.15 15.5 7.05 15.5C23.4 15.5 23.4 15.5 23.4 15.5C27 15.35 30 11.3 30 7.55C30 3.65 26.85 0.5 22.95 0.5Z" />
    </SvgIcon>
  );
}

export default CcfVoiceMailIcon;
